import { render, staticRenderFns } from "./AuctionDetail.vue?vue&type=template&id=006b2ce7&scoped=true"
import script from "./AuctionDetail.vue?vue&type=script&lang=js"
export * from "./AuctionDetail.vue?vue&type=script&lang=js"
import style0 from "./AuctionDetail.vue?vue&type=style&index=0&id=006b2ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b2ce7",
  null
  
)

export default component.exports